import ProtectedImg from '@/components/ProtectedImg';
import { COMMENT_TRUNCATE_LEN_LONG, truncateString } from '@/helpers';
import { MediaCreatedMessage } from '@/queries/community-feed/types';
import { trackMP } from '@/shared/mp';

import Card, { CardProps } from './Card';
import { CardHabitatLink } from './CardLink';
import { getMediaQueryParams } from './utils';

const MediaCreatedCard = ({ messageWithMeta }: CardProps<MediaCreatedMessage>) => {
  const { message } = messageWithMeta;
  const caption = 'media' in message ? message.media.title?.trim() : undefined;
  // Names the media when it has no Caption, so the thumbnail link is never left unlabelled.
  const mediaNoun = 'media' in message && message.media.type === 'video' ? 'clip' : 'photo';
  return (
    <Card messageWithMeta={messageWithMeta}>
      {'media' in message && (
        <div className="mt-2 space-y-2">
          <CardHabitatLink
            message={message}
            query={getMediaQueryParams(message)}
            className="block"
            onClick={() => {
              trackMP('community-feed-clicked', {
                content: 'media',
              });
            }}
          >
            <ProtectedImg
              className="preflight preflight-img block aspect-video w-2/3 overflow-hidden rounded-lg mobile:w-4/5"
              src={message.media.previewURL}
              alt={caption || `A ${mediaNoun}`}
            />
          </CardHabitatLink>
          <p className="preflight preflight-p line-clamp-3 overflow-hidden break-words text-xs">
            {/* The Caption is optional, so quoting it unconditionally produced a bare `""`. With
                none, the media names itself — the thumbnail above is already a link to the same
                place, so nothing is lost by leaving this half unlinked. */}
            {caption ? (
              <>
                &quot;
                <CardHabitatLink
                  message={message}
                  query={getMediaQueryParams(message)}
                  onClick={() => {
                    trackMP('community-feed-clicked', {
                      content: 'media-title',
                    });
                  }}
                >
                  {truncateString(caption, COMMENT_TRUNCATE_LEN_LONG)}
                </CardHabitatLink>
                &quot;
              </>
            ) : (
              <>A {mediaNoun}</>
            )}{' '}
            was just posted to the{' '}
            <CardHabitatLink
              message={message}
              onClick={() => {
                trackMP('community-feed-clicked', {
                  content: 'habitat',
                });
              }}
            >
              {messageWithMeta.message.habitat.title}
            </CardHabitatLink>
          </p>
        </div>
      )}
    </Card>
  );
};

export default MediaCreatedCard;
